module.exports = __webpack_public_path__ + "static/media/earn-money-bg.5e011b66.jpg";